@if (displaySidebar) {
  <div
    class="offcanvas offcanvas-start"
    data-bs-backdrop="false"
    tabindex="-1"
    id="offcanvas-admin-menu"
    aria-labelledby="offcanvas-admin-menuLabel"
    [class.menu-collapsed]="menuCollapsed"
    [class.collapsing-animation]="menuCollapsedAnimation"
    >
    <div class="offcanvas-header">
      <a class="offcanvas-brand" routerLink="/admin"
        ><img src="assets/img/logo-artheau-transparent.png" height="40" /> <em>SIMPLY</em>fly</a
        >
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          [attr.aria-label]="'GENERAL.CLOSE' | translate"
          (click)="menuExpand()"
          >
          @if (!menuCollapsed) {
            <fa-icon [icon]="faChevronLeft"></fa-icon>
          }
          @if (menuCollapsed) {
            <fa-icon [icon]="faChevronRight"></fa-icon>
          }
        </button>
        <div class="menu-inner-shadow"></div>
      </div>
      <div class="offcanvas-body" id="sidebar-body">
        <div class="offcanvas-body-content">
          <div class="input-group input-group-search flex-nowrap mb-3">
            <span class="input-group-text" id="addon-wrapping"
              ><fa-icon [icon]="faSearch"></fa-icon
            ></span>
            <input
              type="search"
              class="form-control"
              [placeholder]="'GENERAL.SEARCH' | translate"
              [(ngModel)]="searchQuery"
              (keyup)="searchKeyUp.next($event.srcElement.value)"
              (search)="searchKeyUp.next($event.srcElement.value)"
              />
          </div>
          @if (searchQuery) {
            @for (searchKey of searchKeys; track searchKey) {
              @if (
                (searchKey.value !== EnumSearchKey.invoices ||
                hasAclAccess(EnumAcl.invoicesSidebarMenu)) &&
                (searchKey.value !== EnumSearchKey.suppliers ||
                hasAclAccess(EnumAcl.suppliersList))
                ) {
                <div
                  class="list-group-header"
                  [innerText]="searchKey.title | translate"
                ></div>
                @if (searchLoading[searchKey.value]) {
                  <ul class="list-group mb-4">
                    @for (item of [].constructor(5); track $index) {
                      <li
                        class="list-group-item placeholder-glow"
                        >
                        <div class="placeholder w-100"></div>
                      </li>
                    }
                  </ul>
                }
                @if (!searchLoading[searchKey.value]) {
                  <div class="list-group mb-4">
                    @if (searchErrors[searchKey.value]) {
                      <div class="list-group-item list-group-item-warning text-center"
                        [innerText]="'SUPPLIERS.SEARCH_UNAVAILABLE' | translate"></div>
                    } @else if (!getSearchResultCount(searchKey.value)) {
                      <div
                        class="list-group-item list-group-item-warning text-center"
                        [innerText]="'GENERAL.NO_DATA_TO_DISPLAY' | translate"
                      ></div>
                    }
                    @if (searchKey.value === EnumSearchKey.enquiries) {
                      @for (item of searchOptions.enquiries; track item.id) {
                        <button
                          type="button"
                          (click)="openItem(EnumSearchKey.enquiries, item)"
                          class="list-group-item list-group-item-action"
                        >
                          <div>
                            @if (item.refContractTitle) {
                              <strong
                                class="d-block"
                                [innerText]="getDisplayedEnquiryRefTitle(item, 'refContract')"
                              ></strong>
                            }
                            <span
                              class="d-block"
                              [innerText]="getDisplayedEnquiryRefTitle(item, 'refEnquiry')"
                            ></span>
                          </div>
                        </button>
                      }
                    }
                    @if (searchKey.value === EnumSearchKey.invoices) {
                      @for (item of searchOptions.invoices; track item.id) {
                        <button
                          type="button"
                          (click)="openItem(EnumSearchKey.invoices, item)"
                          class="list-group-item list-group-item-action"
                        >
                          <div>
                            <div [innerText]="item.ref"></div>
                            {{ formatPrice(item.amountTtcTotal, item.currency) }}
                          </div>
                        </button>
                      }
                    }
                    @if (searchKey.value === EnumSearchKey.airports) {
                      @for (item of searchOptions.airports; track item.id) {
                        <button
                          type="button"
                          (click)="openItem(EnumSearchKey.airports, item)"
                          class="list-group-item list-group-item-action"
                        >
                          <div>
                            @if (item.iataCode) {
                              <div>
                                <strong [innerText]="'AIRPORTS.IATA_CODE' | translate"></strong>:
                                {{ item.iataCode }}
                              </div>
                            }
                            @if (item.icaoCode) {
                              <div>
                                <strong [innerText]="'AIRPORTS.ICAO_CODE' | translate"></strong>:
                                {{ item.icaoCode }}
                              </div>
                            }
                            {{ item.title }}
                          </div>
                        </button>
                      }
                    }
                    @if (searchKey.value === EnumSearchKey.clients) {
                      @for (item of searchOptions.clients; track item.id) {
                        <button
                          type="button"
                          (click)="openItem(EnumSearchKey.clients, item)"
                          class="list-group-item list-group-item-action"
                        >
                          <div>{{ item.name }}</div>
                        </button>
                      }
                    }
                    @if (searchKey.value === EnumSearchKey.suppliers) {
                      @for (item of searchOptions.suppliers; track item.id) {
                        <button
                          type="button"
                          (click)="openItem(EnumSearchKey.suppliers, item)"
                          class="list-group-item list-group-item-action"
                        >
                          <div>{{ item.name }}</div>
                          <small class="text-muted">{{ item.street }}{{ item.street && (item.postalCode || item.city) ? ', ' : '' }}{{ item.postalCode }} {{ item.city }}{{ item.siret ? ' · ' + item.siret : '' }}</small>
                          @if (item.archived) {
                            <span class="badge text-bg-secondary">{{ 'SUPPLIERS.ARCHIVED' | translate }}</span>
                          }
                        </button>
                      }
                    }
                  </div>
                }
              }
            }
          }
            </div>
            @if (!searchQuery.length) {
              <nav>
                <app-sidebar-menu [menuLinks]="menuLinks"></app-sidebar-menu>
              </nav>
            }
            @if (isStaging) {
              <div
                class="staging-info"
                [innerText]="'GENERAL.STAGING_ENVIRONMENT' | translate"
              ></div>
            }
          </div>
        </div>
      }

      <div
        class="main-container"
        [class.has-sidebar]="displaySidebar"
        [class.has-top-menu]="displayTopMenu"
        [class.has-menu-collapsed]="menuCollapsed"
        [class.is-login]="isLoginPage"
        >
        <div class="container-fluid">
          @if (displayTopMenu) {
            <app-header-menu></app-header-menu>
          }

          <main>
            <div [class.d-none]="!hideLoading">
              <router-outlet></router-outlet>
            </div>

            <div class="text-center" id="main-loader" [class.d-none]="hideLoading">
              <div class="spinner-border" role="status"></div>
              {{ "GENERAL.LOADING" | translate }}
            </div>
          </main>
        </div>
      </div>

      <app-alert></app-alert>
      <app-loader></app-loader>
